import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["wrapper", "navigation", "previousButtonContainer", "nextButtonContainer", "nextButton", "finalizeButton"]


  toggleDesiredWeight(event) {
    const checkbox = event.target
    const input = document.getElementById('nutritional_profile_desired_weight')
    
    if (checkbox.checked) {
      input.disabled = true
      input.value = ''
      input.removeAttribute('required')
    } else {
      input.disabled = false
      input.setAttribute('required', 'required')
    }
  }

  toggleMainDoctor(event) {
    const checkbox = event.target
    const input = document.getElementById('nutritional_profile_main_doctor')
    
    if (checkbox.checked) {
      input.disabled = true
      input.value = ''
      input.removeAttribute('required')
    } else {
      input.disabled = false
      input.removeAttribute('required')
    }
  }

  updateSelectStyle(event) {
    const select = event.target
    this.updateSelectStyleForElement(select)
  }

  // Ya no necesitamos actualizar estilos de select para preferencia
  // porque ahora usamos radio buttons

  connect() {
    this.currentStep = this.getCurrentStep()
    // Use event delegation for form buttons
    this.element.addEventListener('click', this.handleButtonClick.bind(this))
    // Update navigation buttons on initial load
    this.updateNavigationButtons(this.currentStep)
    
    // Inicializar estilos de selects al cargar
    this.initializeSelectStyles()
  }

  initializeSelectStyles() {
    // Inicializar estilos de todos los selects custom
    this.element.querySelectorAll('.custom-select').forEach(select => {
      // Verificar si tiene un valor seleccionado
      if (select.value && select.value !== '') {
        select.classList.add('has-value')
      } else {
        select.classList.remove('has-value')
      }
      
      // También forzar la actualización del estilo
      this.updateSelectStyleForElement(select)
    })
  }

  updateSelectStyleForElement(select) {
    // Actualizar la clase del select según si tiene un valor seleccionado
    // (Ya no se usa para preferencia, pero se mantiene para otros selects)
    if (select.value && select.value !== '') {
      select.classList.add('has-value')
    } else {
      select.classList.remove('has-value')
    }
  }

  handleButtonClick(event) {
    const button = event.target.closest('[data-patient-access-form]')
    if (button) {
      event.preventDefault()
      event.stopPropagation()
      const formType = button.getAttribute('data-patient-access-form')
      this.saveAndAdvance(formType, button)
    }
  }

  getCurrentStep() {
    const activeStep = document.querySelector('.patient-access-step[style*="block"]')
    if (activeStep) {
      return parseInt(activeStep.dataset.step)
    }
    return 0
  }


  saveAndAdvance(formType, button) {
    let formId
    switch(formType) {
      case 'patient':
        formId = 'patient-form'
        break
      case 'nutritional-profile':
        formId = 'nutritional-profile-form'
        break
      case 'diagnostic':
        formId = 'diagnostic-form'
        break
      case 'genetic-history':
        formId = 'genetic-history-form'
        break
      case 'food-preferences':
        formId = 'food-preferences-form'
        break
      default:
        return
    }

    const form = document.getElementById(formId)
    if (!form) return

    const formData = new FormData(form)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    // Guardar el texto original del botón antes de cambiarlo
    const originalText = button.innerHTML
    if (!button.hasAttribute('data-original-text')) {
      button.setAttribute('data-original-text', originalText)
    }

    // Disable button during submission
    button.disabled = true
    button.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>Guardando...'

    fetch(form.action, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        // Try to parse error response
        return response.text().then(text => {
          let errorData
          try {
            errorData = JSON.parse(text)
          } catch (e) {
            errorData = { errors: [`Error HTTP ${response.status}: ${text.substring(0, 200)}`] }
          }
          throw new Error(JSON.stringify(errorData))
        })
      }
      return response.json()
    })
    .then(data => {
      if (data.success) {
        // Restaurar el botón antes de avanzar
        button.disabled = false
        const originalText = button.getAttribute('data-original-text') || '<i class="fas fa-arrow-right mr-2"></i>Siguiente'
        button.innerHTML = originalText

        // Si el botón tiene un atributo data-patient-access-summary-url, redirigir al resumen
        const summaryUrl = button.getAttribute('data-patient-access-summary-url')
        if (summaryUrl) {
          window.location.href = summaryUrl
        } else {
          // Advance to next step
          this.nextStep()
        }
      } else {
        // Restaurar el botón en caso de error
        button.disabled = false
        const originalText = button.getAttribute('data-original-text') || '<i class="fas fa-arrow-right mr-2"></i>Siguiente'
        button.innerHTML = originalText

        // Show error message
        const messageDiv = document.getElementById(`${formId}-message`)
        if (messageDiv) {
          messageDiv.className = 'alert alert-danger mt-3'
          const errorMessage = data.errors ? (Array.isArray(data.errors) ? data.errors.join(', ') : data.errors) : (data.message || 'Error al guardar')
          messageDiv.textContent = errorMessage
          messageDiv.classList.remove('d-none')
        }
      }
    })
    .catch(error => {
      // Restaurar el botón en caso de error de red u otro error
      button.disabled = false
      const originalText = button.getAttribute('data-original-text') || '<i class="fas fa-arrow-right mr-2"></i>Siguiente'
      button.innerHTML = originalText
      
      const messageDiv = document.getElementById(`${formId}-message`)
      if (messageDiv) {
        messageDiv.className = 'alert alert-danger mt-3'
        let errorMessage = 'Error al guardar. Por favor, intente nuevamente.'

        try {
          const errorData = JSON.parse(error.message)
          if (errorData.errors) {
            errorMessage = Array.isArray(errorData.errors) ? errorData.errors.join(', ') : errorData.errors
          } else if (errorData.message) {
            errorMessage = errorData.message
          }
        } catch (e) {
          // If it's not JSON, show the original error message
          if (error.message && !error.message.includes('JSON')) {
            errorMessage = error.message
          }
        }

        messageDiv.textContent = errorMessage
        messageDiv.classList.remove('d-none')
      }
    })
  }

  nextStep() {
    const steps = [0, 1, 4]
    const currentIndex = steps.indexOf(this.currentStep)

    if (currentIndex < steps.length - 1) {
      const nextStepIndex = steps[currentIndex + 1]
      this.showStep(nextStepIndex)
      this.updateProgress(nextStepIndex)
      this.currentStep = nextStepIndex

      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  previousStep() {
    const steps = [0, 1, 4]
    const currentIndex = steps.indexOf(this.currentStep)

    if (currentIndex > 0) {
      const prevStepIndex = steps[currentIndex - 1]
      this.showStep(prevStepIndex)
      this.updateProgress(prevStepIndex)
      this.currentStep = prevStepIndex

      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  showStep(stepIndex) {
    // Hide all steps
    document.querySelectorAll('.patient-access-step').forEach(step => {
      step.style.display = 'none'
    })

    // Show selected step
    const stepElement = document.querySelector(`.patient-access-step[data-step="${stepIndex}"]`)
    if (stepElement) {
      stepElement.style.display = 'block'
    }

    // Update current step
    this.currentStep = stepIndex

    // Update navigation buttons visibility
    this.updateNavigationButtons(stepIndex)
  }

  updateNavigationButtons(stepIndex) {
    const steps = [0, 1, 4]
    const currentIndex = steps.indexOf(stepIndex)

    // Obtener los contenedores y botones usando querySelector como fallback
    const previousContainer = this.hasPreviousButtonContainerTarget
      ? this.previousButtonContainerTarget
      : document.querySelector('[data-patient-access-target="previousButtonContainer"]')

    const nextContainer = this.hasNextButtonContainerTarget
      ? this.nextButtonContainerTarget
      : document.querySelector('[data-patient-access-target="nextButtonContainer"]')

    const nextButton = this.hasNextButtonTarget
      ? this.nextButtonTarget
      : document.querySelector('[data-patient-access-target="nextButton"]')

    const finalizeButton = this.hasFinalizeButtonTarget
      ? this.finalizeButtonTarget
      : document.querySelector('[data-patient-access-target="finalizeButton"]')

    // Actualizar botón Anterior
    if (previousContainer) {
      if (currentIndex > 0) {
        previousContainer.style.display = 'block'
        // Ajustar columnas: anterior ocupa 4, siguiente/finalizar ocupa 8
        if (nextContainer) {
          nextContainer.className = 'col-12 col-md-8'
        }
      } else {
        previousContainer.style.display = 'none'
        // Primer paso: siguiente ocupa todo el ancho
        if (nextContainer) {
          nextContainer.className = 'col-12'
        }
      }
    }

    // Actualizar botones Siguiente/Finalizar
    if (stepIndex === 4) {
      // Último paso: mostrar Finalizar, ocultar Siguiente
      if (nextButton) {
        nextButton.style.display = 'none'
      }
      if (finalizeButton) {
        finalizeButton.style.display = 'block'
      }
    } else {
      // Otros pasos: mostrar Siguiente, ocultar Finalizar
      if (finalizeButton) {
        finalizeButton.style.display = 'none'
      }
      if (nextButton) {
        nextButton.style.display = 'block'
        // Actualizar el tipo de formulario según el paso
        const formTypes = {
          0: 'patient',
          1: 'nutritional-profile'
        }
        if (formTypes[stepIndex]) {
          nextButton.setAttribute('data-patient-access-form', formTypes[stepIndex])
        }
      }
    }
  }

  updateProgress(stepIndex) {
    const steps = [0, 1, 4]
    const stepElements = document.querySelectorAll('.progress-steps .step')

    stepElements.forEach((stepEl, index) => {
      const stepValue = steps[index]
      stepEl.classList.remove('active', 'completed')

      if (stepValue === stepIndex) {
        stepEl.classList.add('active')
      } else if (steps.indexOf(stepValue) < steps.indexOf(stepIndex)) {
        stepEl.classList.add('completed')
      }
    })
  }
}
